module.exports = __webpack_public_path__ + "img/index.c5017789.jpg";